import { flow, get, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getImportItemsQuantityResult = get(
  'inventory.components.importItemsQuantityResult'
);

export const getItemsQuantity = createSelector(
  getImportItemsQuantityResult,
  flow(
    get('items'),
    orderBy('counter', 'desc')
  )
);
